interface ITransactionInformationModalRowProps {
  label: string;
  value?: string | number | React.ReactNode;
}

export const TransactionInformationModalRow: React.FC<
  ITransactionInformationModalRowProps
> = (props) => {
  const { label, value } = props;

  return (
    <div className="flex items-center justify-between gap-2 py-3">
      <span className="text-sm font-medium text-grey-dark">{label}:</span>
      {typeof value === "object" ? (
        value
      ) : (
        <span className="overflow-hidden break-words text-right text-sm font-semibold text-base-black">
          {value}
        </span>
      )}
    </div>
  );
};
